import L from "leaflet";
import "leaflet-control-geocoder";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAppConfigContext } from "./hooks/AppConfigContext";
import { useMap } from "./hooks/MapContext";
import { MapRouterContext } from "./hooks/MapRouterContext";

const MapRouterProvider = MapRouterContext.Provider;

export default function MapRouterContainer({ children }) {
  const appConfig = useAppConfigContext();
  const map = useMap();

  const routerControl = useRef(null);

  const [wayPoints, setWayPoints] = useState([]);

  const setStart = useCallback((evt) => {
    setWayPoints((current) => {
      return [evt.latlng].concat(current);
    });
  }, []);

  const setEnd = useCallback((evt) => {
    setWayPoints((current) => {
      return current.concat([evt.latlng]);
    });
  }, []);

  const setWayPoint = useCallback((evt) => {
    setWayPoints((current) => {
      return current.concat([evt.latlng]);
    });
  }, []);

  const clear = useCallback(() => {
    setWayPoints([]);
  }, []);

  useEffect(() => {
    if (routerControl.current) {
      routerControl.current.setWaypoints(wayPoints);
      routerControl.current.show();
    }
  }, [routerControl, wayPoints]);

  useEffect(() => {
    if (map && appConfig && !routerControl.current) {
      const control = L.Routing.control({
        language: "pt_BR",
        formatter: new L.Routing.Formatter({
          language: "pt_BR",
        }),
        router: L.routing.mapbox(appConfig?.mapboxToken ?? ""),
        plan: L.Routing.plan([], {
          createMarker: function (i, wp) {
            return L.marker(wp.latLng, {
              draggable: false,
              icon: L.icon.glyph({ glyph: String.fromCodePoint(65 + i) }),
            }).on("click", () => {
              routerControl.current.show();
            });
          },
          geocoder: L.Control.Geocoder.photon(),
          language: "pt_BR",
        }),
        showAlternatives: true,
        addWaypoints: false,
        draggableWaypoints: false,
        fitSelectedRoutes: true,
        show: false,
        collapsible: true,
        altLineOptions: {
          styles: [
            { color: "black", opacity: 0.15, weight: 9 },
            { color: "white", opacity: 0.8, weight: 6 },
            { color: "blue", opacity: 0.5, weight: 2 },
          ],
        },
      });

      control
        .on("linetouched", (evt) => {
          evt.preventDefault();
        })
        .addTo(map);

      routerControl.current = control;

      map.contextmenu.addItem({
        text: "Rota: origem",
        callback: setStart,
      });

      map.contextmenu.addItem({
        text: "Rota: destino",
        callback: setWayPoint,
      });

      map.contextmenu.addItem({
        text: "Rota: destino final",
        callback: setEnd,
      });

      map.contextmenu.addItem({
        text: "Limpar",
        callback: clear,
      });
    }
  }, [appConfig, clear, map, setStart, setWayPoint, setEnd]);

  return (
    <MapRouterProvider value={routerControl}>{children}</MapRouterProvider>
  );
}
